import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
    "target",
    "template",
    "emptyMessage"
  ]

  static values = {
    wrapperSelector: {
      type: String,
      default: ".nested-form-wrapper",
    }
  }

  connect() {
    this.updateUI()
  }

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.targetTarget.insertAdjacentHTML("beforeend", content)

    const customEvent = new CustomEvent("nested-form:add", { bubbles: true })
    this.element.dispatchEvent(customEvent)

    this.updateUI()
  }

  remove(event) {
    event.preventDefault()

    const wrapper = event.target.closest(this.wrapperSelectorValue)

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      wrapper.style.display = "none"

      const input = wrapper.querySelector("input[name*='_destroy']")
      input.value = "1"
    }

    const customEvent = new CustomEvent("rails-nested-form:remove", { bubbles: true })
    this.element.dispatchEvent(customEvent)

    this.updateUI()
  }

  // @private
  updateUI() {
    // Show or hide the "empty message" that gets displayed when there are no nested forms
    // currently visible.
    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.hidden = this.noOfVisibleNestedForms > 0
    }

    // Show or hide the target element based on the number of visible nested forms.
    // We hide the target with `display: none !important` to ensure it is not displayed
    // and also works when styling the element using flexbox and gap utilities.
    if (this.noOfVisibleNestedForms <= 0) {
      this.targetTarget.style.setProperty("display", "none", "important")
    } else {
      this.targetTarget.style.setProperty("display", "inherit")
    }
  }

  // @private
  get noOfVisibleNestedForms() {
    // Find all wrapper that are not hidden and directly children of the target element
    const visibleWrappers = Array.from(this.targetTarget.children)
      .filter(wrapper => wrapper.matches(this.wrapperSelectorValue) && wrapper.style.display !== "none")
    return visibleWrappers.length
  }
}
